import { SURVEY_LIST, REFRESH_CARD } from "../actions/types";

const initState = {
  type: SURVEY_LIST,
  survey_list: []
};

const surveyReducer = (state = initState, action) => {
  switch (action.type) {
    case SURVEY_LIST:
      return {
        type: SURVEY_LIST,
        survey_list: action.survey_list
      };
    case REFRESH_CARD:
        return {
          type: REFRESH_CARD,
          card_refresh: action.survey_refresh
        };
    default:
      return state;
  }
};

export default surveyReducer;
